module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_vm._v("For Liam"), _c('br'), _c('br'), _vm._v("Here’s a nice jungle: glades of trust"), _c('br'), _vm._v("Disturbed by parakeets of lust,"), _c('br'), _vm._v("Pools of deceptive calm where need"), _c('br'), _vm._v("Bathes among crocodiles of greed.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61c828ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/strangeloyalties_00000.vue
// module id = 66
// module chunks = 0